import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

// Layout
import Home from "./pages/index/Home";
const DirectorioPage = lazy(() => import("./pages/directorio/DirectorioPage"));

//Enlaces
const ProcesosElectorales = lazy(() => import("./pages/enlaces/ProcesosElectorales/ProcesosElectorales"));
const HistorialPE = lazy(() => import("./pages/enlaces/ProcesosElectorales/HistorialPE"));
const PE20152016 = lazy(() => import("./pages/enlaces/ProcesosElectorales/PE20152016"));
const PEE2017 = lazy(() => import("./pages/enlaces/ProcesosElectorales/PEE2017"));
const PE2018 = lazy(() => import("./pages/enlaces/ProcesosElectorales/PE2018"));
const PE20202021 = lazy(() => import("./pages/enlaces/ProcesosElectorales/PE20202021"));
const PE20232024 = lazy(() => import("./pages/enlaces/ProcesosElectorales/PE20232024"));
const PEPJ20242025 = lazy(() => import("./pages/enlaces/ProcesosElectorales/PEPJ20242025"));
const Normatividad = lazy(() => import("./pages/enlaces/Normatividad"));
const Galeria = lazy(() => import("./pages/enlaces/Galeria/Galeria"));
const GaleriaTot = lazy(() => import("./pages/enlaces/Galeria/GaleriaTot"));

const Oic = lazy(() => import("./pages/enlaces/OIC/Oicc"));
const GaleriaOIC = lazy(() => import("./pages/enlaces/OIC/GaleriaOIC"));
const AcuerdosOIC = lazy(() => import("./pages/enlaces/OIC/AcuerdosOIC"));
const Infografias = lazy(() => import("./pages/enlaces/Infografias"));
const MemoriasElectorales = lazy(() => import("./pages/enlaces/MemoriasElectorales"));
const MetasMSPEN = lazy(() => import("./pages/enlaces/MetasMSPEN"));
const PartidosPoliticos = lazy(() => import("./pages/enlaces/PartidosPoliticos"));

const ProcesOrdin = lazy(() => import("./pages/enlaces/ProcesOrdin"));
const ProcesExtraordin = lazy(() => import("./pages/enlaces/ProcesExtraordin"));

const PersonasDiscapacidad = lazy(() => import("./pages/enlaces/PersonasDiscapacidad"));
const Informes = lazy(() => import("./pages/enlaces/Informes"));

const InformesAnualesITE = lazy(() => import("./pages/enlaces/InformesAnualesITE"));

//Acerca de ITE
const FinesInstitucionales = lazy(() => import("./pages/acercaITE/FinesInstitucionales"));
const Historia = lazy(() => import("./pages/acercaITE/Historia"));
const PrincipiosRectores = lazy(() => import("./pages/acercaITE/PrincipiosRectores"));
const EstructuraOrganica = lazy(() => import("./pages/acercaITE/EstructuraOrganica"));

//Consejo General
const Integracion = lazy(() => import("./pages/consejoGeneral/Integracion"));
const Comisiones = lazy(() => import("./pages/consejoGeneral/Comisiones"));
const Jge = lazy(() => import("./pages/consejoGeneral/Jgee"));
const Estructura = lazy(() => import("./pages/consejoGeneral/Estructura"));

//Acuerdos INE
const AcuerdosINE = lazy(() => import("./pages/acuerdos/acuerdosINE/AcuerdosINE"));
const AcuerdosTableINE = lazy(() => import("./pages/acuerdos/acuerdosINE/AcuerdosTableINE"));
const AcuerdosINE2025 = lazy(() => import("./pages/acuerdos/acuerdosINE/AcuerdosINE2025"));
const AcuerdosINE2026 = lazy(() => import("./pages/acuerdos/acuerdosINE/AcuerdosINE2026"));

//Acuerdos ITE
const AcuerdosAnteriores = lazy(() => import("./pages/acuerdos/AcuerdosAnteriores"));
const AcuerdosTableITE = lazy(() => import("./pages/acuerdos/acuerdosITE/AcuerdosTableITE"));
const Acuerdos2001 = lazy(() => import("./pages/acuerdos/acuerdosITE/Acuerdos2001"));
const Acuerdos2002 = lazy(() => import("./pages/acuerdos/acuerdosITE/Acuerdos2002"));
const AcuerdosITE = lazy(() => import("./pages/acuerdos/acuerdosITE/AcuerdosITE"));
const Acuerdos2025 = lazy(() => import("./pages/acuerdos/acuerdosITE/Acuerdos2025"));
const Acuerdos2026 = lazy(() => import("./pages/acuerdos/acuerdosITE/Acuerdos2026"));

//Demarcaciones
const Acuerdos = lazy(() => import("./pages/demarcaciones/Acuerdos"));
const Distritacion2015 = lazy(() => import("./pages/demarcaciones/Distritacion2015"));
const Distritacion2022 = lazy(() => import("./pages/demarcaciones/Distritacion2022"));
const DistritacionPJ2025 = lazy(() => import("./pages/demarcaciones/DistritacionPJ2025"));
const Mapas = lazy(() => import("./pages/demarcaciones/Mapas"));
const MapasPJ = lazy(() => import("./pages/demarcaciones/MapasPJ"));
const AcuerdosPJ = lazy(() => import("./pages/demarcaciones/AcuerdosPJ"));

//Transparencia
const Transparencia = lazy(() => import("./pages/transparencia/Transparencia"));

//Transparencia Artículo 63
const Articulo63 = lazy(() => import("./pages/transparencia/art63/Articulo63"));
const Art63Table = lazy(() => import("./pages/transparencia/art63/Art63Table"));
const Art632024 = lazy(() => import("./pages/transparencia/art63/Art632024"));
const Art632025 = lazy(() => import("./pages/transparencia/art63/Art632025"));
const Art632026 = lazy(() => import("./pages/transparencia/art63/Art632026"));


//Transparencia Artículo 67
const Articulo67 = lazy(() => import("./pages/transparencia/art67/Articulo67"));
const Art67Table = lazy(() => import("./pages/transparencia/art67/Art67Table"));
const Art672024 = lazy(() => import("./pages/transparencia/art67/Art672024"));
const Art672025 = lazy(() => import("./pages/transparencia/art67/Art672025"));
const Art672026 = lazy(() => import("./pages/transparencia/art67/Art672026"));

//Transparencia Artículo 94
const Articulo94 = lazy(() => import("./pages/transparencia/art94/Articulo94"));
const Art94Table = lazy(() => import("./pages/transparencia/art94/Art94Table"));


//obligacionesC
const ObligacionesC = lazy(() => import("./pages/transparencia/obliC/ObligacionesC"));
const ObligacionesCTable = lazy(() => import("./pages/transparencia/obliC/ObligacionesC2026"));
//obligacionesE
const ObligacionesE = lazy(() => import("./pages/transparencia/obliE/ObligacionesE"));
const ObligacionesETable = lazy(() => import("./pages/transparencia/obliE/ObligacionesE2026"));
//TablaA
const TablaA = lazy(() => import("./pages/transparencia/tablaA/TablaA"));
const TablaATable = lazy(() => import("./pages/transparencia/tablaA/TablaA2026"));


const InformesAnuales = lazy(() => import("./pages/transparencia/transp/InformesAnuales"));

const FormatoSolicitud = lazy(() => import("./pages/transparencia/transp/FormatoSolicitud"));
const Poa = lazy(() => import("./pages/transparencia/transp/Poaa"));
const InformacionFinanciera = lazy(() => import("./pages/transparencia/transp/InformacionFinanciera"));
const InformacionContable = lazy(() => import("./pages/transparencia/transp/InformacionContable"));

const Section = lazy(() => import("./pages/transparencia/transp/planes/Section"));
const Planes2024 = lazy(() => import("./pages/transparencia/transp/planes/Planes2024"));
const Planes2025 = lazy(() => import("./pages/transparencia/transp/planes/Planes2025"));

const Convenios = lazy(() => import("./pages/transparencia/transp/convens/Convenios"));
const Convenios2014 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2014"));
const Convenios2015 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2015"));
const Convenios2016 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2016"));
const Convenios2017 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2017"));
const Convenios2018 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2018"));
const Convenios2019 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2019"));
const Convenios2020 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2020"));
const Convenios2021 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2021"));
const Convenios2022 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2022"));
const Convenios2023 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2023"));
const Convenios2024 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2024"));
const Convenios2025 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2025"));
const Convenios2026 = lazy(() => import("./pages/transparencia/transp/convens/Convenios2026"));

const AvisosPrivacidad = lazy(() => import("./pages/transparencia/transp/avisos/Avisos"));
const AvisosPriv2020 = lazy(() => import("./pages/transparencia/transp/avisos/AvisosPriv2020"));
const AvisosPriv2021 = lazy(() => import("./pages/transparencia/transp/avisos/AvisosPriv2021"));
const AvisosPriv2022 = lazy(() => import("./pages/transparencia/transp/avisos/AvisosPriv2022"));
const AvisosPriv2023 = lazy(() => import("./pages/transparencia/transp/avisos/AvisosPriv2023"));
const AvisosPriv2024 = lazy(() => import("./pages/transparencia/transp/avisos/AvisosPriv2024"));
const AvisosPriv2025 = lazy(() => import("./pages/transparencia/transp/avisos/AvisosPriv2025"));
const AvisosPriv2026 = lazy(() => import("./pages/transparencia/transp/avisos/AvisosPriv2026"));

const PreguntasFrecuentes = lazy(() => import("./pages/transparencia/PreguntasFrecuentes"));
const DatosAbiertos = lazy(() => import("./pages/transparencia/DatosAbiertos"));

//Comunicacion Social
const BoletinesTable = lazy(() => import("./pages/comunicacionSocial/boletines/BoletinesTable"));

const MonitoreosTable = lazy(() => import("./pages/comunicacionSocial/monitoreos/MonitoreosTable"));
const Monitoreos2024 = lazy(() => import("./pages/comunicacionSocial/monitoreos/Monitoreos2024"));
const Monitoreos2025 = lazy(() => import("./pages/comunicacionSocial/monitoreos/Monitoreos2025"));

const MonitoreosPELE2024 = lazy(() => import("./pages/comunicacionSocial/monitoreos/MonitoreoPELE2024"));

const ITEConecta = lazy(() => import("./pages/comunicacionSocial/ITEConecta"));
const EnCorto = lazy(() => import("./pages/comunicacionSocial/EnCorto"));
//Cultura Cívica
const ActividadesLudicas = lazy(() => import("./pages/culturaCivica/ActividadesLudicas"));
const EleccionesEscolares = lazy(() => import("./pages/culturaCivica/EleccionesEscolares"));
const ParlamentoInfantil = lazy(() => import("./pages/culturaCivica/ParlamentoInfantil"));
const ParlamentoJuvenil = lazy(() => import("./pages/culturaCivica/ParlamentoJuvenil"));
const ValoresDemocracia = lazy(() => import("./pages/culturaCivica/ValoresDemocracia"));

//Archivo
const InfografiasArchivo = lazy(() => import("./pages/archivo/InfografiasArchivo"));
const InstrumentosArchivisticos = lazy(() => import("./pages/archivo/InstrumentosArchivisticos"));
const InstrumentosNormativos = lazy(() => import("./pages/archivo/InstrumentosNormativos"));
const PlaneacionArchivistica = lazy(() => import("./pages/archivo/PlaneacionArchivistica"));

//Convocatorias

const ConvocatoriasApartado = lazy(() => import("./pages/ConvocatoriasApartado/ConvocatoriasApartado"));

//Micrositios
const Reps = lazy(() => import("./pages/reps/Repss"));

//Memoria Electoral
const MemoriaElectoral20202021 = lazy(() => import("./pages/memElect2023/MemoriaElectoral20202021"));
const EstradosElectronicos = lazy(() => import("./pages/EstradosElectronicos/EstradosElectronicos"));

const Licitaciones = lazy(() => import("./pages/licitaciones/Licitaciones"));

const NotFound = lazy(() => import("./layout/NotFound"));

const AppRoutes = () => (
  <Suspense fallback={<div className="d-flex justify-content-center my-5 p-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Cargando...</span></div></div>}>
    <Routes>
    <Route path="*" element={<NotFound />} />

    <Route exact path="/" element={<Home />} />

    {/* Enlaces */}
    <Route path="/ProcesosElectorales" element={<ProcesosElectorales />} />
    <Route path="/PE20152016" element={<PE20152016 />} />
    <Route path="/PEE2017" element={<PEE2017 />} />
    <Route path="/PE2018" element={<PE2018 />} />
    <Route path="/PE20202021" element={<PE20202021 />} />
    <Route path="/PE20232024" element={<PE20232024 />} />
    <Route path="/PEPJ20242025" element={<PEPJ20242025 />} />
    <Route path="/HistorialPE" element={<HistorialPE />} />
    <Route path="/Normatividad" element={<Normatividad />} />
    <Route path="/Galeria" element={<Galeria />} />
    {/* <Route path="/Galeria2016" element={<GaleriaTot year="2016" />} />
    <Route path="/Galeria2017" element={<GaleriaTot year="2017" />} />
    <Route path="/Galeria2018" element={<GaleriaTot year="2018" />} />
    <Route path="/Galeria2019" element={<GaleriaTot year="2019" />} />
    <Route path="/Galeria2020" element={<GaleriaTot year="2020" />} />
    <Route path="/Galeria2021" element={<GaleriaTot year="2021" />} />
    <Route path="/Galeria2022" element={<GaleriaTot year="2022" />} />
    <Route path="/Galeria2023" element={<GaleriaTot year="2023" />} /> */}
    <Route path="/Galeria2024" element={<GaleriaTot year="2024" />} />
    <Route path="/Galeria2025" element={<GaleriaTot year="2025" />} />
    <Route path="/Galeria2026" element={<GaleriaTot year="2026" />} />
    <Route path="/OIC" element={<Oic />} />
    <Route path="/GaleriaOIC" element={<GaleriaOIC />} />
    <Route path="/AcuerdosOIC" element={<AcuerdosOIC />} />
    <Route path="/Infografias" element={<Infografias />} />
    <Route path="/MemoriasElectorales" element={<MemoriasElectorales />} />
    <Route path="/MetasMSPEN" element={<MetasMSPEN />} />
    <Route path="/PartidosPoliticos" element={<PartidosPoliticos />} />

    <Route path="/proceso-ordinario" element={<ProcesOrdin />} />
    <Route path="/proceso-extraordinario" element={<ProcesExtraordin />} />

    <Route path="/PersonasDiscapacidad" element={<PersonasDiscapacidad />} />
    <Route path="/Informes" element={<Informes />} />
    <Route path="/InformesAnualesITE" element={<InformesAnualesITE />} />

    {/* Acerca de ITE */}
    <Route path="/FinesInstitucionales" element={<FinesInstitucionales />} />
    <Route path="/Historia" element={<Historia />} />
    <Route path="/PrincipiosRectores" element={<PrincipiosRectores />} />
    <Route path="/EstructuraOrganica" element={<EstructuraOrganica />} />

    {/* Consejo General */}
    <Route path="/Integracion" element={<Integracion />} />
    <Route path="/Comisiones" element={<Comisiones />} />
    <Route path="/JGE" element={<Jge />} />
    <Route path="/Estructura" element={<Estructura />} />

    {/* Acuerdos ITE */}
    <Route path="/AcuerdosAnteriores" element={<AcuerdosAnteriores />} />
    <Route path="/AcuerdosINE" element={<AcuerdosINE />} />

    <Route path="/Acuerdos1998" element={<AcuerdosTableITE year="1998" />} />
    <Route path="/Acuerdos2001" element={<Acuerdos2001 />} />
    <Route path="/Acuerdos2002" element={<Acuerdos2002 />} />
    <Route path="/Acuerdos2003" element={<AcuerdosTableITE year="2003" />} />
    <Route path="/Acuerdos2004" element={<AcuerdosTableITE year="2004" />} />
    <Route path="/Acuerdos2005" element={<AcuerdosTableITE year="2005" />} />
    <Route path="/Acuerdos2006" element={<AcuerdosTableITE year="2006" />} />
    <Route path="/Acuerdos2007" element={<AcuerdosTableITE year="2007" />} />
    <Route path="/Acuerdos2008" element={<AcuerdosTableITE year="2008" />} />
    <Route path="/Acuerdos2009" element={<AcuerdosTableITE year="2009" />} />
    <Route path="/Acuerdos2010" element={<AcuerdosITE year="2010" />} />
    <Route path="/Acuerdos2011" element={<AcuerdosITE year="2011" />} />
    <Route path="/Acuerdos2012" element={<AcuerdosTableITE year="2012" />} />
    <Route path="/Acuerdos2013" element={<AcuerdosITE year="2013" />} />
    <Route path="/Acuerdos2014" element={<AcuerdosITE year="2014" />} />
    <Route path="/Acuerdos2015" element={<AcuerdosTableITE year="2015" />} />
    <Route path="/Acuerdos2016" element={<AcuerdosTableITE year="2016" />} />
    <Route path="/Acuerdos2017" element={<AcuerdosTableITE year="2017" />} />
    <Route path="/Acuerdos2018" element={<AcuerdosTableITE year="2018" />} />
    <Route path="/Acuerdos2019" element={<AcuerdosTableITE year="2019" />} />
    <Route path="/Acuerdos2020" element={<AcuerdosTableITE year="2020" />} />
    <Route path="/Acuerdos2021" element={<AcuerdosTableITE year="2021" />} />
    <Route path="/Acuerdos2022" element={<AcuerdosTableITE year="2022" />} />
    <Route path="/Acuerdos2023" element={<AcuerdosTableITE year="2023" />} />
    <Route path="/Acuerdos2024" element={<AcuerdosTableITE year="2024" />} />
    <Route path="/Acuerdos2025" element={<Acuerdos2025 year="2025" />} />
    <Route path="/Acuerdos2026" element={<Acuerdos2026 year="2026" />} />

    {/* Acuerdos INE */}
    <Route path="/AcuerdosINE2015" element={<AcuerdosTableINE year="2015" />} />
    <Route path="/AcuerdosINE2016" element={<AcuerdosTableINE year="2016" />} />
    <Route path="/AcuerdosINE2020" element={<AcuerdosTableINE year="2020" />} />
    <Route path="/AcuerdosINE2021" element={<AcuerdosTableINE year="2021" />} />
    <Route path="/AcuerdosINE2022" element={<AcuerdosTableINE year="2022" />} />
    <Route path="/AcuerdosINE2023" element={<AcuerdosTableINE year="2023" />} />
    <Route path="/AcuerdosINE2024" element={<AcuerdosTableINE year="2024" />} />
    <Route path="/AcuerdosINE2025" element={<AcuerdosINE2025 year="2025" />} />
    <Route path="/AcuerdosINE2026" element={<AcuerdosINE2026 year="2026" />} />

    {/* Demarcaciones */}
    <Route path="/Acuerdos" element={<Acuerdos />} />
    <Route path="/Distritacion2015" element={<Distritacion2015 />} />
    <Route path="/Distritacion2022" element={<Distritacion2022 />} />
    <Route path="/DistritacionPJ2025" element={<DistritacionPJ2025 />} />
    <Route path="/Mapas" element={<Mapas />} />
    <Route path="/MapasPJ" element={<MapasPJ />} />
    <Route path="/AcuerdosPJ" element={<AcuerdosPJ />} />

    {/* Transparencia */}
    <Route path="/Transparencia" element={<Transparencia />} />

    {/* ANTES DE MARZO DE 2026*/}

    {/* Artículo 63 */}
    <Route path="/Articulo63" element={<Articulo63 />} />
    <Route path="/Art632017" element={<Art63Table year="2017" />} />
    <Route path="/Art632018" element={<Art63Table year="2018" />} />
    <Route path="/Art632019" element={<Art63Table year="2019" />} />
    <Route path="/Art632020" element={<Art63Table year="2020" />} />
    <Route path="/Art632021" element={<Art63Table year="2021" />} />
    <Route path="/Art632022" element={<Art63Table year="2022" />} />
    <Route path="/Art632023" element={<Art63Table year="2023" />} />
    <Route path="/Art632024" element={<Art632024 />} />
    <Route path="/Art632025" element={<Art632025 />} />
    <Route path="/Art632026" element={<Art632026 />} />

    {/* Artículo 67 */}
    <Route path="/Articulo67" element={<Articulo67 />} />
    <Route path="/Art672017" element={<Art67Table year="2017" />} />
    <Route path="/Art672018" element={<Art67Table year="2018" />} />
    <Route path="/Art672019" element={<Art67Table year="2019" />} />
    <Route path="/Art672020" element={<Art67Table year="2020" />} />
    <Route path="/Art672021" element={<Art67Table year="2021" />} />
    <Route path="/Art672022" element={<Art67Table year="2022" />} />
    <Route path="/Art672023" element={<Art67Table year="2023" />} />
    <Route path="/Art672024" element={<Art672024 />} />
    <Route path="/Art672025" element={<Art672025 />} />
    <Route path="/Art672026" element={<Art672026 />} />

    {/* Artículo 94 */}
    <Route path="/Articulo94" element={<Articulo94 />} />
    <Route path="/Art942020" element={<Art94Table year="2020" />} />
    <Route path="/Art942021" element={<Art94Table year="2021" />} />
    <Route path="/Art942026" element={<Art94Table year="2026" />} />

    {/* A PARTIR DE ABRIL 2026*/}

    {/* ObligacionesC */}
    <Route path="/ObligacionesC" element={<ObligacionesC />} />
    <Route path="/ObligacionesC2026" element={<ObligacionesCTable />} />

    {/* ObligacionesE */}
    <Route path="/ObligacionesE" element={<ObligacionesE />} />
    <Route path="/ObligacionesE2026" element={<ObligacionesETable />} />

    {/* TablaA */}
    <Route path="/TablaA" element={<TablaA />} />
    <Route path="/TablaA2026" element={<TablaATable />} />



    {/* Transparencia General */}
    <Route path="/InformesAnuales" element={<InformesAnuales />} />

    <Route path="/FormatoSolicitud" element={<FormatoSolicitud />} />
    <Route path="/POA" element={<Poa />} />
    <Route path="/InformacionFinanciera" element={<InformacionFinanciera />} />
    <Route path="/InformacionContable" element={<InformacionContable />} />

    <Route path="/Section" element={<Section />} />
    <Route path="/Planes2024" element={<Planes2024 />} />
    <Route path="/Planes2025" element={<Planes2025 />} />

    <Route path="/Convenios" element={<Convenios />} />
    <Route path="/Convenios2014" element={<Convenios2014 />} />
    <Route path="/Convenios2015" element={<Convenios2015 />} />
    <Route path="/Convenios2016" element={<Convenios2016 />} />
    <Route path="/Convenios2017" element={<Convenios2017 />} />
    <Route path="/Convenios2018" element={<Convenios2018 />} />
    <Route path="/Convenios2019" element={<Convenios2019 />} />
    <Route path="/Convenios2020" element={<Convenios2020 />} />
    <Route path="/Convenios2021" element={<Convenios2021 />} />
    <Route path="/Convenios2022" element={<Convenios2022 />} />
    <Route path="/Convenios2023" element={<Convenios2023 />} />
    <Route path="/Convenios2024" element={<Convenios2024 />} />
    <Route path="/Convenios2025" element={<Convenios2025 />} />
    <Route path="/Convenios2026" element={<Convenios2026 />} />

    <Route path="/AvisosPrivacidad" element={<AvisosPrivacidad />} />
    <Route path="/AvisosPriv2020" element={<AvisosPriv2020 />} />
    <Route path="/AvisosPriv2021" element={<AvisosPriv2021 />} />
    <Route path="/AvisosPriv2022" element={<AvisosPriv2022 />} />
    <Route path="/AvisosPriv2023" element={<AvisosPriv2023 />} />
    <Route path="/AvisosPriv2024" element={<AvisosPriv2024 />} />
    <Route path="/AvisosPriv2025" element={<AvisosPriv2025 />} />
    <Route path="/AvisosPriv2026" element={<AvisosPriv2026 />} />

    <Route path="/Infografias" element={<Infografias />} />
    <Route path="/PreguntasFrecuentes" element={<PreguntasFrecuentes />} />
    <Route path="/DatosAbiertos" element={<DatosAbiertos />} />

    {/* Comunicación Social */}
    <Route path="/Boletines2015" element={<BoletinesTable year="2015" />} />
    <Route path="/Boletines2016" element={<BoletinesTable year="2016" />} />
    <Route path="/Boletines2017" element={<BoletinesTable year="2017" />} />
    <Route path="/Boletines2019" element={<BoletinesTable year="2019" />} />
    <Route path="/Boletines2020" element={<BoletinesTable year="2020" />} />
    <Route path="/Boletines2021" element={<BoletinesTable year="2021" />} />
    <Route path="/Boletines2022" element={<BoletinesTable year="2022" />} />
    <Route path="/Boletines2023" element={<BoletinesTable year="2023" />} />
    <Route path="/Boletines2024" element={<BoletinesTable year="2024" />} />
    <Route path="/Boletines2025" element={<BoletinesTable year="2025" />} />
    <Route path="/Boletines2026" element={<BoletinesTable year="2026" />} />

    <Route path="/Monitoreos2015" element={<MonitoreosTable year="2015" />} />
    <Route path="/Monitoreos2016" element={<MonitoreosTable year="2016" />} />
    <Route path="/Monitoreos2017" element={<MonitoreosTable year="2017" />} />
    <Route path="/Monitoreos2018" element={<MonitoreosTable year="2018" />} />
    <Route path="/Monitoreos2020" element={<MonitoreosTable year="2020" />} />
    <Route path="/Monitoreos2021" element={<MonitoreosTable year="2021" />} />
    <Route path="/Monitoreos2023" element={<MonitoreosTable year="2023" />} />
    <Route path="/Monitoreos2024" element={<Monitoreos2024 />} />
    <Route path="/Monitoreos2025" element={<Monitoreos2025 />} />

    <Route path="/MonitoreosPELE2024" element={<MonitoreosPELE2024 />} />

    <Route path="/ITEConecta" element={<ITEConecta />} />
    <Route path="/EnCorto" element={<EnCorto />} />

    {/* Cultura Cívica */}
    <Route path="/ActividadesLudicas" element={<ActividadesLudicas />} />
    <Route path="/EleccionesEscolares" element={<EleccionesEscolares />} />
    <Route path="/ParlamentoInfantil" element={<ParlamentoInfantil />} />
    <Route path="/ParlamentoJuvenil" element={<ParlamentoJuvenil />} />
    <Route path="/ValoresDemocracia" element={<ValoresDemocracia />} />

    {/* Archivo */}
    <Route path="/InfografiasArchivo" element={<InfografiasArchivo />} />
    <Route
      path="/InstrumentosArchivisticos"
      element={<InstrumentosArchivisticos />}
    />
    <Route
      path="/InstrumentosNormativos"
      element={<InstrumentosNormativos />}
    />
    <Route
      path="/PlaneacionArchivistica"
      element={<PlaneacionArchivistica />}
    />

    {/* Convocatorias */}
    <Route path="/ConvocatoriasApartado" element={<ConvocatoriasApartado />} />

    {/* Estrados Electrónicos */}
    <Route path="/EstradosElectronicos" element={<EstradosElectronicos />} />

    {/* Licitaciones */}
    <Route path="/licitaciones" element={<Licitaciones />} />

    {/* Micrositios */}
    <Route path="/REPS" element={<Reps />} />

    {/* MemoriaElectoral20202021 */}
    <Route
      path="/MemoriaElectoral20202021"
      element={<MemoriaElectoral20202021 />}
    />

    {/* Directorio General */}
    <Route path="/Directorio" element={<DirectorioPage />} />
    <Route path="/directorio" element={<DirectorioPage />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
